import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './components/contexts/RoomTypeRatePlanContext';
import { RoomsProvider } from './components/contexts/RoomsContext';
import { CheckoutProvider } from "./components/contexts/CheckoutContext";
import { HashRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
/*root.render(
  <React.StrictMode>
    <BrowserRouter>
    <RoomsProvider>
        <AppProvider>
          <CheckoutProvider>
            <App />
          </CheckoutProvider>
        </AppProvider>
      </RoomsProvider>
    </BrowserRouter>
  </React.StrictMode>
);*/
root.render(
  <BrowserRouter>
    <RoomsProvider>
      <AppProvider>
        <CheckoutProvider>
          <App />
        </CheckoutProvider>
      </AppProvider>
    </RoomsProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();